const GetNextPage = (currentPage, pageStructure) => {

    const pagesToConsider = pageStructure.filter(p => p.Visible);
    const currentIndex = pagesToConsider.findIndex((page) => { return page.Name === currentPage.Name})
    const newPage = pagesToConsider[currentIndex+1];
    return newPage;
}

export default GetNextPage;